import { query } from '@/utils/request';

// 用户中心-获取全量租户树
export const fetchAllTenantData = () => {
  return query('/api/zlbuser/tenant/tree');
};

// 用户中心-逐级获取租户树
export const fetchLevelTenantData = ({ tenantCode, ...params }) => {
  return query(`/api/zlbuser/tenant/tree/${tenantCode}`, {
    params,
  });
};

// 报销侧-获取租户树
export const fetchExpenseCommonTenantTree = (params) => {
  return query(`/zlb/api/expense/common/tenant-tree`, {
    params
  });
};


// 费控侧-获取费控租户树
export function fetchFeeControlStandardTenantTree (params) {
  return query('/zlb/cost/control/standard/tenant-tree', {
    params,
  });
}
